import(/* webpackMode: "eager", webpackExports: ["CertificadoForm"] */ "/vercel/path0/frontend/src/app/sdc/certificados/components/CertificadoForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Container","Description"] */ "/vercel/path0/frontend/src/app/sdc/certificados/styles.ts");
